import type React from 'react';

/**
 * @example
 * <form onKeyPress={disableFormSubmitOnEnter}>
 */
export const disableFormSubmitOnEnter = (
  e: KeyboardEvent | React.KeyboardEvent,
): void => {
  if (e.key === 'Enter') {
    e.preventDefault();
  }
};
